import { useTypedSelector } from '@hooks/useTypedSelector';

/**
 * Киллсвич центра настроек уведомлений: страница /settings/notifications, шестерёнка в
 * колокольчике, пункты «Настроить»/«Не уведомлять» в меню уведомления, mute в шапке документа.
 * Управляется бэком — CanView.SettingsNotifications из AppSettings:UserSettings:ShowNotifications
 * (по умолчанию включено). Сравнение именно с false: до успешного логина (и в сторис/тестах без
 * auth-стейта) флаг ещё не загружен — прячем только по явному запрету бэка.
 */
export const useNotificationPreferencesEnabled = (): boolean =>
    useTypedSelector((state) => state.auth.user.canView.settingsNotifications !== false);
